import type { ReactNode } from 'react'
import { AlertTriangle } from 'lucide-react'
import { cx } from './cx'

export interface ErrorBannerProps {
  title: ReactNode
  description?: ReactNode
  onRetry?: () => void
  // 'critical' for failures, 'warning' for partial or stale data
  tone?: 'critical' | 'warning'
}

export function ErrorBanner({ title, description, onRetry, tone = 'critical' }: ErrorBannerProps) {
  const critical = tone === 'critical'
  return (
    <div
      role={critical ? 'alert' : 'status'}
      className={cx(
        'flex items-start gap-3 rounded-[10px] border px-4 py-3.5',
        critical ? 'border-critical-line bg-critical-tint' : 'border-warning-line bg-warning-tint'
      )}
    >
      <AlertTriangle className={cx('mt-px h-[18px] w-[18px] flex-none', critical ? 'text-critical' : 'text-warning')} aria-hidden="true" />
      <div className="flex flex-1 flex-col gap-0.5 text-ink">
        <span className="font-semibold">{title}</span>
        {description && <span className="text-[13px] text-ink-secondary">{description}</span>}
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className={cx(
            'h-8 rounded-lg border bg-surface px-3 text-[13px] font-semibold text-ink',
            'focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-focus',
            critical ? 'border-critical-line' : 'border-warning-line'
          )}
        >
          Retry
        </button>
      )}
    </div>
  )
}
